/**
 * XML Bağlantısı — Ana Kabuk
 * ============================================================================
 * 2 sekmeli yapı (Iter-44 sadeleştirmesi):
 *   • Kurulum             — Feed özeti, Manuel Eşleştirme, Otomatik Eşleştirme
 *   • Eşleştirme Geçmişi  — Son 20 iş (tarih, süre, yeni/güncellenen/pasif, rollback)
 *
 * Kaldırılan tab'lar (tarihi):
 *   • Ürünler — Products sayfası zaten filtrelerle bu ihtiyacı karşılıyor
 *   • Tehlike Bölgesi — Merchant kilitli, destructive op'lar Sayz'da
 */
import { useState } from "react";
import { Wrench, History } from "lucide-react";
import XmlWizardTab from "@/pages/xml/XmlWizardTab";
import XmlHistoryTab from "@/pages/xml/XmlHistoryTab";
import { XmlFeedProvider } from "@/lib/xml-feed";
import XmlAlertsBanner from "@/pages/xml/XmlAlertsBanner";

const TABS = [
    { id: "wizard",  label: "Kurulum",             icon: Wrench,  testId: "xml-tab-wizard"  },
    { id: "history", label: "Eşleştirme Geçmişi",  icon: History, testId: "xml-tab-history" },
];

export default function XmlConnectionWizard() {
    const [active, setActive] = useState("wizard");

    return (
        <XmlFeedProvider>
            <div className="space-y-4" data-testid="integration-xml-tab">
                {/* Ardışık başarısız eşleştirme uyarıları */}
                <XmlAlertsBanner />

                {/* Alt-sekme çubuğu */}
                <div className="rounded-xl border border-border bg-surface p-1 flex items-center gap-1 flex-wrap" role="tablist">
                    {TABS.map((tb) => (
                        <button
                            key={tb.id}
                            role="tab"
                            aria-selected={active === tb.id}
                            onClick={() => setActive(tb.id)}
                            className={`inline-flex items-center gap-2 h-9 px-3 rounded-md text-[12.5px] font-medium transition-colors ${
                                active === tb.id
                                    ? "bg-foreground text-background"
                                    : "text-muted-foreground hover:bg-muted hover:text-foreground"
                            }`}
                            data-testid={tb.testId}
                        >
                            <tb.icon className="h-3.5 w-3.5" strokeWidth={2} />
                            {tb.label}
                        </button>
                    ))}
                </div>

                {active === "wizard"  && <XmlWizardTab  />}
                {active === "history" && <XmlHistoryTab />}
            </div>
        </XmlFeedProvider>
    );
}
